import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'

import { syncAppointmentTypes } from './services/mutateAppointmentTypes'
import { invalidateLoadAppointmentTypes } from './useLoadAppointmentTypes'

export const useSyncAppointmentTypes = (
  options?: Omit<
    UseMutationOptions<void, Error, void, unknown>,
    'mutationKey' | 'mutationFn' | 'onSuccess'
  >
) => {
  const mutation = useMutation({
    mutationKey: [QUERIES.AUTOMATIONS.APPOINTMENT_TYPES.SYNC],
    mutationFn: async () => await syncAppointmentTypes(),
    onSuccess: async () => await invalidateLoadAppointmentTypes(),
    ...options,
  })

  const syncAppointmentTypeReq = async () => {
    return mutation.mutateAsync()
  }

  return {
    syncAppointmentType: syncAppointmentTypeReq,
    ...mutation,
  }
}
